import React, { useCallback, useMemo } from "react";
import styled from "styled-components";

import { Box, Flex, Text } from "atoms";

import {
  useLocationQueryAdd,
  useLocationQueryValue,
} from "hooks/useLocationQuery";
import { variant } from "styled-system";
import MemoSortArrow from "assets/icons/SortArrow";

const StyledTable = styled.table`
  border-collapse: collapse;
  width: 100%;

  ${variant({
    variants: {
      primary: {
        tr: {
          height: "6.3rem",
        },
        td: {
          p: "1rem 1.5rem",
          fontFamily: "NeometricRegular",
          fontSize: "1.6rem",
          color: "neutral.800",
        },

        th: {
          zIndex: 1,
          p: "1rem 1.5rem",
          fontSize: "1.6rem",
          backgroundColor: "neutral.50",
          whiteSpace: "nowrap",
        },
      },
    },
  })}
`;

export const Table = ({
  children,
  variant = "primary",
  tableHeader,
  containerProps,
  ...props
}) => {
  const sortOrder = useLocationQueryValue("sort");
  const setParam = useLocationQueryAdd();

  const isDesc = useMemo(() => !!(sortOrder?.[0] === "-"), [sortOrder]);
  const sort = useMemo(
    () => (isDesc ? sortOrder.slice(1) : sortOrder),
    [sortOrder, isDesc]
  );

  const onSort = useCallback(
    (sortKey) => () => {
      if (sortKey) {
        setParam("sort", !isDesc && sortKey === sort ? `-${sortKey}` : sortKey);
        // setParam("page", "1");
      }
    },
    [sort, setParam, isDesc]
  );

  return (
    <Box
      overflowX={{ xs: "scroll", lg: "scroll" }}
      maxWidth="calc(100vw - 6.8rem)"
      {...containerProps}
    >
      <StyledTable variant={variant} as="table" {...props}>
        {tableHeader && (
          <thead>
            <tr>
              {tableHeader.map((t, index) => (
                <Box
                  as="th"
                  key={index}
                  onClick={onSort(t?.sortKey)}
                  cursor={t?.sortKey ? "pointer" : undefined}
                  {...t?.containerProps}
                >
                  <Flex aI="center" jC="left">
                    <Text fontFamily="NeometricRegular" color="neutral.800">
                      {t.name}
                    </Text>

                    {t?.sortKey ? (
                      <Flex alignItems="center" ml="1.6rem">
                        {/* {t.sortKey === sort ? ( */}
                        <Box
                          transition="all 0.1s"
                          color={
                            t?.sortKey === sort ? "primary.900" : "neutral.500"
                          }
                          // transform={isDesc ? "rotate(180deg) translateY(-3px)" : undefined}
                        >
                          <MemoSortArrow width="1.3rem" />
                        </Box>
                        {/* ) : (
                          <Box>
                            <Box color="primary.900">
                              <MemoSortArrow width="1.3rem" />
                            </Box>
                          </Box>
                        )} */}
                      </Flex>
                    ) : null}
                  </Flex>
                </Box>
              ))}
            </tr>
          </thead>
        )}
        {children}
      </StyledTable>
    </Box>
  );
};
